import './Passes.css';
import { useState, useEffect,useRef } from 'react';
import annualpass from '../../../../assets/images/annualpass.jpg';
import daypass from '../../../../assets/images/daypass.gif';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import DatePicker from 'react-datepicker'; // Import the DatePicker
import 'react-datepicker/dist/react-datepicker.css'; // Import the CSS
import '@fortawesome/fontawesome-free/css/all.min.css';
import { FaCalendarAlt } from 'react-icons/fa';
import { CartUpdateService } from '../../../../services/CartUpdateService';
import { CART_BASE_URL,PASS_BASE_URL } from '../../../../config/ApiConfig';
import { showNotification } from '../../../../services/NotificationService';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export const Passes = () => {
    const navigate = useNavigate();
    const [item, setItem] = useState(1); 
    const [selectedDate, setSelectedDate] = useState('');
    const location = useLocation();
    const { passID,passGUID } = location.state || {};
    const id = passID;
    const [passData,setPassData]= useState({});
    const [freeDates, setFreeDates] = useState([]);
    const [isFreeDate, setIsFreeDate] = useState(false);
    const [isFreeDateMessage, setIsFreeDateMessage] = useState(false);
    const datePickerRef = useRef(null); // Reference for the DatePicker and input
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(()=>{
        if(!passGUID){
            navigate('/');
        }
    },[])

    useEffect(()=>{
        setErrorMessage('');
        const fetchPassDetails = async()=>{
            try {
                const response = await axios.get(`${PASS_BASE_URL}/GetPassDetailsbyGUID/${passGUID}`);
                const data = response.data.data;
                setPassData(data);
            } catch (error) {
                console.error("Error fetching pass details:", error);
                showNotification("Oops! Something went wrong. Please try again later.", "error");
                setErrorMessage(`We couldn't retrieve the Pass at the moment. We apologize for the inconvenience. Please refresh the page or try again later.`);
            }
        }
        if(id){
            fetchPassDetails();
        }
    },[id]);    

    // Fetch Free Dates
    useEffect(() => {
        const fetchFreeDates = async () => {
            try {
                const currentYear = new Date().getFullYear();
                const response = await axios.get(`${PASS_BASE_URL}/GetFreeDaysByYear?year=${currentYear}`);
                const freeDays = response.data.data.map(day => day.date); // Store as string, exactly as API
                setFreeDates(freeDays);  
            } catch (error) {
                console.error("Error fetching free dates:", error);
            }
        };
        if (passData && passData.passID && passData.passID !== 1) { 
            fetchFreeDates();
        }
    }, [passData.passID]);

    // Check if selected date is a free date
    useEffect(() => {
        setIsFreeDate(freeDates.includes(selectedDate));
    }, [selectedDate, freeDates]);

    const decreaseQuantity = () => {
        if (!isFreeDate){
            setItem(prev => Math.max(prev - 1, 1));
        }
    }

    const increaseQuantity = () => {
        if (!isFreeDate){
            setItem(prev => prev + 1);
        }
    };
    const totalPrice = item * (passData.price + passData.processingFee);

    // Handle Free Dates
    const isDateFree = (date) => {
        if (!date) return false; // Return false if date is null or invalid
         return freeDates.some(freeDate => 
            new Date(freeDate + "T00:00:00").toDateString() === date.toDateString()
        );
    };

    const dayClassName = (date) => {
        return isDateFree(date) ? 'free-date' : undefined;
    };

    const handleDateChange = (date) => {
        if (isDateFree(date)) {
            setSelectedDate(''); // Reset the date if it's a free date
            setIsFreeDateMessage(true);
        } else {
            setSelectedDate(date); // Set selected date
            setIsFreeDateMessage(false);
        }
    };

     // Hide message when clicking outside DatePicker/input
     useEffect(() => {
        const handleClickOutside = (event) => {
            if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
                setIsFreeDateMessage(false);
            }
        };
    
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const isValidDate = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const selected = new Date(date);
        return selected >= today;
    };

    const generateAnnualPassDate = () => {
        // Get current date in UTC
        const now = new Date();
        // Convert to Pacific Time (America/Los_Angeles) using Intl.DateTimeFormat
        const pacificDate = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/Los_Angeles',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(now);
    
        // Convert the formatted date back to a Date object
        const [month, day, year] = pacificDate.split('/');
        return new Date(`${year}-${month}-01T00:00:00-08:00`); // Always first day of the month
    };
    
    // Utility function to format date consistently  ok works earlier
    const formatDateToLocal = (date) => {
        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(localDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}T00:00:00`;
    };

    const cartSubmitHandler = async(event) => {
        event.preventDefault();
        if (isFreeDate) {
            alert('This date is a free date! No need to add to cart.');
            return;
        }
        let dateInfo = selectedDate;
        if (passData.passID === 1) {
            dateInfo = generateAnnualPassDate();
        } else if (!isValidDate(selectedDate)) {
            return;
        }
        dateInfo = formatDateToLocal(dateInfo);
        const cartInfo = {
            passID: passData.passID,
            longName: passData.longName,
            passDate: dateInfo,
            quantity: item, // Quantity being added
            price: passData.price,
            totalPrice: totalPrice,
            processingFee: passData.processingFee,
        };
        // Load existing cart from session storage
        const existingCart = JSON.parse(sessionStorage.getItem('wa_crt_itms')) || [];
        const existingItemIndex = existingCart.findIndex(order => order.passID === cartInfo.passID && order.passDate === cartInfo.passDate);
        if (existingItemIndex >= 0) {
            // If the item already exists, update the quantity and total price
            existingCart[existingItemIndex].quantity += item; // Add new quantity to existing
            existingCart[existingItemIndex].totalPrice = existingCart[existingItemIndex].quantity * (passData.price + passData.processingFee);
        } else {
            // Add new item to the cart
            existingCart.push(cartInfo);
        }
        // Store cart in session storage
        sessionStorage.setItem('wa_crt_itms', JSON.stringify(existingCart));
        //Store the pass in datebase for specific CartGUId if it exist
        const cartGUID= sessionStorage.getItem('wa_crt_cid');
        if(cartGUID){
            try {
                let payload;
                if (cartGUID) {
                  const response = await axios.get(
                    `${CART_BASE_URL}/GetCartDetailsByGUID/${cartGUID}`,
                  );
                  const existingCartItems = response.data.data.cartDetails.passes || [];
                  const cartID= response.data.data.cartDetails.cartID;            
                  const databaseItemIndex = existingCartItems.findIndex(
                    (item) =>
                      item.passID === cartInfo.passID && item.passDate === cartInfo.passDate
                  ); 
                  if (databaseItemIndex >= 0) {
                    existingCartItems[databaseItemIndex].quantity += cartInfo.quantity;
                    existingCartItems[databaseItemIndex].totalPrice =
                      existingCartItems[databaseItemIndex].quantity *
                      (passData.price + passData.processingFee);
                  } else {
                    existingCartItems.push({
                      passID: passData.passID,
                      quantity: item,
                      passDate: dateInfo,
                    });
                  }
                  payload = {
                    cartID, // Include the cartID here
                    passes: existingCartItems.map((item) => ({
                      cartItemID: item.cartItemID,
                      passID: item.passID,
                      quantity: item.quantity,
                      passDate: item.passDate,
                    })),
                  };

                } else {
                  payload = {
                    passes: [
                      {
                        passID: cartInfo.passID,
                        quantity: cartInfo.quantity,
                        passDate: cartInfo.passDate,
                      },
                    ],
                  };
                }
                const responseData = await axios.post(
                  `${CART_BASE_URL}/SaveUpdateCart`,
                  payload,
                  {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  },
                );
                if (responseData.data && !cartGUID) {                    
                  sessionStorage.setItem("wa_crt_cid", responseData.data.data.cartGUID);
                }
              } catch (error) {
                console.error("Error updating the cart:", error);
                showNotification("Unable to update the cart at the moment.", "error");
              }

              // For Header I need to do this -Trigger the update event so other components can listen
              CartUpdateService.updateCart({ updated: true });
              //----------This above line is useful for header only, no use in Passes Component
        }

        navigate('/cart');
    }  
    if (errorMessage) {
        return <div className="errorHandling"><h3 className="errorHandles">{errorMessage}</h3></div>;
    }
    return (
        <div className='passes my-5'>
            <div className="contentBG d-flex mx-auto w-100">
                {Object.keys(passData).length > 0?
                    <>
                    <div className='row pass-row'>
                        <div className="content-left col-12 col-lg-9 col-xl-9">
                        <h1 className='py-1'>{passData.longName}</h1>
                            <p>{passData.indexDescription}</p>
                            <h3 className="mt-3">Product Details</h3>
                            <div dangerouslySetInnerHTML={{ __html: passData.feature }} />
                            <h3 className="mt-3">Delivery Method</h3>
                            <div dangerouslySetInnerHTML={{ __html: passData.deliveryMethod }} />
                            <hr></hr>
                            <form onSubmit={cartSubmitHandler}>
                                <div className='purchase'>
                                    <div className="fw-bold fs-3">${(passData.price + passData.processingFee).toFixed(2)} <span>Includes ${passData.processingFee.toFixed(2)} processing fee per pass</span></div>
                                </div>
                                {passData.passID !== 1 && (
                                    <label className="date-label d-flex fw-bold mt-3" htmlFor="date">What date will the pass be used? (MM/DD/YYYY)</label>
                                )}
                                <div className="add-to-cart atc-oneday d-flex  align-items-center">
                                    {passData.passID !== 1 && (
                                        <div id="dateEntryBox" role="application" ref={datePickerRef} className='date-picker-wrapper'>
                                            <DatePicker
                                                id="date"
                                                selected={selectedDate}
                                                onChange={handleDateChange}
                                                minDate={new Date()} // Set minimum to today's date
                                                className="date-entry"
                                                placeholderText="MM/DD/YYYY"
                                                required
                                                dayClassName={dayClassName} // Apply class to free dates
                                            />
                                            <span className="calendar-icon position-absolute"><FaCalendarAlt /></span>
                                        </div>
                                    )}
                                    <div className="quantityBox passesQuantity">
                                        <span className="label-small">Quantity</span>
                                        <div className=" quantity d-flex align-items-center">
                                            <button type="button" className="quantity-change btn btn-outline" onClick={decreaseQuantity}>–</button>
                                            <div className="quantity-amount" id="qtyDiv">{item}</div>
                                            <button type="button" className="quantity-change btn btn-outline-secondary" onClick={increaseQuantity}>+</button>
                                        </div>
                                    </div>
                                    <input type="submit" className="add-button mt-4" value="Add to Cart" />
                                </div>
                                {isFreeDateMessage && (
                                    <p className='freeBox' >The day you selected is a State Parks Free Day, no pass is required. Enjoy your visit!</p>
                                )}
                            </form>
                        </div>
                        <div className="content-right">
                            <h1>{passData.longName}</h1>
                            <img src={passData.image === 'annualpass.gif' ? annualpass : daypass} alt="Pass"></img>
                        </div>
                    </div>
                    </>:<>
                    <div className="skeleton-wrapper d-flex flex-column">
                        <Skeleton height={30} width="100px" />
                        <Skeleton height={15} width="60%" />
                        <Skeleton height={15} width="50%" />
                        <Skeleton height={100} width="100%" />
                        <Skeleton height={30} width="40%" />
                        <Skeleton count={5} width="80%" />
                    </div>
                    </>
                    }
            </div>
        </div>
    );
};